import { Context } from "./Context";
var DependencyInjector = /** @class */ (function () {
    function DependencyInjector() {
        this.values = [];
    }
    DependencyInjector.prototype.getInstance = function (classToRetrieve, subname, createIfPossible) {
        if (subname === void 0) { subname = 'default'; }
        if (createIfPossible === void 0) { createIfPossible = true; }
        var existing = this.findExistingInstance(classToRetrieve, subname);
        if (existing)
            return existing;
        var instance = null;
        if (createIfPossible)
            instance = this.returnBest(classToRetrieve, subname);
        if (instance === null) {
            console.warn('Tried to initialize a class with DependencyInjector, but wasnt successful', classToRetrieve);
            throw new Error('unable_find_or_create_instance_for_class');
        }
        return instance;
    };
    DependencyInjector.prototype.register = function (classToRetrieve, instance, subname) {
        if (subname === void 0) { subname = 'default'; }
        for (var _i = 0, _a = this.values; _i < _a.length; _i++) {
            var o = _a[_i];
            if (o.subname === subname && o.classProto + '' === classToRetrieve + '') {
                o.instance = instance;
                return;
            }
        }
        this.values.push({
            subname: subname,
            classProto: classToRetrieve,
            instance: instance
        });
    };
    DependencyInjector.prototype.returnBest = function (classToRetrieve, subname) {
        if (subname === void 0) { subname = 'default'; }
        var existing = this.findExistingInstance(classToRetrieve, subname);
        if (existing)
            return existing;
        var newInstance = new classToRetrieve();
        this.register(classToRetrieve, newInstance, subname);
        return newInstance;
    };
    DependencyInjector.prototype.findExistingInstance = function (classToRetrieve, subname) {
        if (subname === void 0) { subname = 'default'; }
        for (var _i = 0, _a = this.values; _i < _a.length; _i++) {
            var o = _a[_i];
            if (o.subname === subname && o.classProto + '' === classToRetrieve + '')
                return o.instance;
        }
        return null;
    };
    return DependencyInjector;
}());
export { DependencyInjector };
export function DependencyInjectorInstance() {
    if (typeof Context.getGlobalContext()['di'] === 'undefined' ||
        Context.getGlobalContext()['di'] === null) {
        var Inj = new DependencyInjector();
        Context.getGlobalContext()['di'] = Inj;
        // console.log('register');
    }
    return Context.getGlobalContext()['di'];
}
export function Autowire(classToInject, subname) {
    if (subname === void 0) { subname = 'default'; }
    // Inj.need(keys[0]);
    return function (target, key) {
        // property getter
        var getter = function () {
            var Inj = DependencyInjectorInstance();
            return Inj.getInstance(classToInject, subname);
        };
        // Delete property.
        if (delete target[key]) {
            Object.defineProperty(target, key, {
                get: getter
            });
        }
    };
}
//# sourceMappingURL=DependencyInjector.js.map